import React from 'react';
import useCallApi from '../../hooks/useCallApi';
import useRequired from '../../hooks/useRequired';
import InputControlMask from './InputControlMask';
import Loading from './Loading';

const DropDownInput = ({ 
    id, 
    field='',
    fieldSelect='',
    label, 
    type = 'text',
    placeholder='', 
    value='', 
    valueReadOnly= false,
    classNameContainer = '',
    classNameInput = '',
    onChange=()=>'',
    onChangeSelect=()=>'',
    valueSelect='',
    dataProvider = [],
    mask = '',
    pattern=undefined, 
    title='',
    textFormatter = undefined,
}) => {

    const { required } = useRequired();

    const { data, loading } = useCallApi(dataProvider);

    const cssClassContainer = `${classNameContainer} sg-input  mt-15`;
    const cssClassInput = `${classNameInput} sg-input-field  w60`;

    return (
        <div className={cssClassContainer}>
            
            <label htmlFor={id}>{label}</label>

            <div className="group-dropdown">
                {loading ? 
                    <Loading classNameDiv="w40" classNameInput="w100"/> :
                    <select name={fieldSelect} className="sg-input-select sg-input-select_grouped w40" id={id} onChange={onChangeSelect} value={valueSelect}>
                        {data && data.map((item, i) => <option  key={i} value={item.value}>{textFormatter != undefined ? textFormatter(item) : item.text}</option>)}
                    </select>
                }

                {
                    mask ?  
                    <InputControlMask  
                        name={field} 
                        onChange={onChange} 
                        className={cssClassInput}
                        type={type} 
                        id={id} 
                        placeholder={placeholder} 
                        value={value} 
                        mask={mask} 
                        required = {required}
                        pattern={pattern}
                        title={title}
                        readOnly={valueReadOnly}
                    />
                    :
                    <input                     
                        name={field} 
                        onChange={onChange} 
                        className={cssClassInput}
                        type={type} 
                        id={id} 
                        placeholder={placeholder} 
                        value={value} 
                        required = {required}
                        pattern={pattern}
                        title={title}
                        readOnly={valueReadOnly}
                    /> 
                }
            </div>
        </div>
    );
}



export default DropDownInput;
